export default "__VITE_ASSET__DLxWhdKd__"